import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4dd47cd1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "common-layout"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("灯塔考研--技术支持")
const _hoisted_3 = {
  key: 1,
  class: "common-layout"
}

import Header from '@/components/Header.vue'
import Side from '@/components/Side.vue'
import { onMounted } from 'vue';
import { useRoute,useRouter } from 'vue-router';
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
onMounted(() => {
  let token = localStorage.getItem('ACCESS_TOKEN')
  if (!token) {
    ElMessage.error('请重新登陆')
    router.push({ path: '/login' })
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!

  return (!(_unref(route).path === '/login'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, null, {
              default: _withCtx(() => [
                _createVNode(Header)
              ]),
              _: 1
            }),
            _createVNode(_component_el_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_aside, { width: "200px" }, {
                  default: _withCtx(() => [
                    _createVNode(Side)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_main, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_view)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_footer, null, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_component_router_view)
      ]))
}
}

})